import React, { createContext, useContext, useState, useEffect } from "react";

// ─── Helper Formatters ────────────────────────────────────────────────────────
const getYoutubeLabel = (lang) => {
  const raw = Number(process.env.REACT_APP_SUBSCRIBERS || 0);
  const val = raw > 0 ? (raw / 100).toFixed(1) : "4.8";
  if (lang === "hi") return `${val} लाख+`;
  if (lang === "ur") return `${val} لاکھ+`;
  return `${val}L+`;
};

const getInstagramLabel = () => {
  const raw = Number(process.env.REACT_APP_INSTAGRAM || 0);
  const val = raw > 0 ? String(raw) : "135";
  return `${val}K+`;
};

// ─── Video Data (language-tagged) ─────────────────────────────────────────────
export const VIDEOS = [
  // English Videos
  {
    id: "en_1",
    lang: "en",
    title: "Turmeric Glow Mask — Full Tutorial",
    description: "Get glowing skin in 15 minutes with this simple kitchen remedy.",
    thumbnail: "https://img.youtube.com/vi/dQw4w9WgXcQ/hqdefault.jpg", // replace with real ID
    youtubeId: "dQw4w9WgXcQ",
    category: "skin",
    duration: "8:24",
    views: "52K",
  },
  {
    id: "en_2",
    lang: "en",
    title: "Onion Juice Hair Serum — Step by Step",
    description: "Reduce hair fall by 80% with this proven Ayurvedic serum.",
    thumbnail: "https://img.youtube.com/vi/dQw4w9WgXcQ/hqdefault.jpg",
    youtubeId: "dQw4w9WgXcQ",
    category: "hair",
    duration: "11:05",
    views: "41K",
  },
  {
    id: "en_3",
    lang: "en",
    title: "DIY Multani Mitti Anti-Acne Pack",
    description: "Control oil and banish acne with this deep pore mask.",
    thumbnail: "https://img.youtube.com/vi/dQw4w9WgXcQ/hqdefault.jpg",
    youtubeId: "dQw4w9WgXcQ",
    category: "acne",
    duration: "6:50",
    views: "44K",
  },

  // Hindi Videos (हिंदी)
  {
    id: "hi_1",
    lang: "hi",
    title: "हल्दी ग्लो मास्क — पूरी विधि",
    description: "15 मिनट में चमकती त्वचा पाएं इस सरल रसोई उपाय से।",
    thumbnail: "https://img.youtube.com/vi/dQw4w9WgXcQ/hqdefault.jpg",
    youtubeId: "dQw4w9WgXcQ",
    category: "skin",
    duration: "8:24",
    views: "52 हजार",
  },
  {
    id: "hi_2",
    lang: "hi",
    title: "प्याज का रस हेयर सीरम — स्टेप बाय स्टेप",
    description: "इस आयुर्वेदिक सीरम से बालों का झड़ना 80% कम करें।",
    thumbnail: "https://img.youtube.com/vi/dQw4w9WgXcQ/hqdefault.jpg",
    youtubeId: "dQw4w9WgXcQ",
    category: "hair",
    duration: "11:05",
    views: "41 हजार",
  },
  {
    id: "hi_3",
    lang: "hi",
    title: "मुल्तानी मिट्टी एंटी-एक्ने पैक",
    description: "इस डीप पोर मास्क से तेल और मुहांसों को नियंत्रित करें।",
    thumbnail: "https://img.youtube.com/vi/dQw4w9WgXcQ/hqdefault.jpg",
    youtubeId: "dQw4w9WgXcQ",
    category: "acne",
    duration: "6:50",
    views: "44 हजार",
  },
  {
    id: "hi_4",
    lang: "hi",
    title: "चावल का पानी — बालों को मजबूत बनाएं",
    description: "फर्मेंटेड चावल पानी से बाल मजबूत और चमकदार बनाएं।",
    thumbnail: "https://img.youtube.com/vi/dQw4w9WgXcQ/hqdefault.jpg",
    youtubeId: "dQw4w9WgXcQ",
    category: "hair",
    duration: "9:15",
    views: "38 हजार",
  },

  // Urdu Videos (اردو)
  {
    id: "ur_1",
    lang: "ur",
    title: "ہلدی گلو ماسک — مکمل طریقہ",
    description: "اس سادہ گھریلو نسخے سے 15 منٹ میں چمکتی جلد پائیں۔",
    thumbnail: "https://img.youtube.com/vi/dQw4w9WgXcQ/hqdefault.jpg",
    youtubeId: "dQw4w9WgXcQ",
    category: "skin",
    duration: "8:24",
    views: "52K",
  },
  {
    id: "ur_2",
    lang: "ur",
    title: "پیاز کا رس ہیئر سیرم — مرحلہ وار",
    description: "اس آیورویدک سیرم سے بالوں کا گرنا 80% کم کریں۔",
    thumbnail: "https://img.youtube.com/vi/dQw4w9WgXcQ/hqdefault.jpg",
    youtubeId: "dQw4w9WgXcQ",
    category: "hair",
    duration: "11:05",
    views: "41K",
  },
  {
    id: "ur_3",
    lang: "ur",
    title: "ملتانی مٹی اینٹی ایکنی پیک",
    description: "اس ڈیپ پور ماسک سے تیل اور کیل مہاسوں کو کنٹرول کریں۔",
    thumbnail: "https://img.youtube.com/vi/dQw4w9WgXcQ/hqdefault.jpg",
    youtubeId: "dQw4w9WgXcQ",
    category: "acne",
    duration: "6:50",
    views: "44K",
  },
];

// ─── Translations ─────────────────────────────────────────────────────────────
const TRANSLATIONS = {
  en: {
    dir: "ltr",
    font: "'Inter', sans-serif",
    headingFont: "'Playfair Display', serif",
    siteName: "Tanya Fashion Skincare",
    siteTagline: "DIY Beauty Remedies",
    navHome: "Home",
    navCategories: "Categories",
    navPopular: "Popular",
    navBackHome: "Back to Home",
    heroBadge: "50+ Proven Natural Remedies",
    heroTitle: "Natural Beauty Remedies That",
    heroHighlight: "Actually Work!",
    heroDesc: `Transform your skin and hair with time-tested DIY remedies using simple kitchen ingredients. No expensive products needed — just nature's finest, proven by ${getYoutubeLabel("en")} community members!`,
    tag1: "100% Natural",
    tag2: "Kitchen Ingredients",
    tag3: "Proven Results",
    tag4: "Zero Side Effects",
    btnYouTube: "Watch Tutorials on YouTube",
    btnAI: "Try AI Face Analysis",
    stat1Val: "50+",
    stat1: "DIY Remedies",
    stat2Val: getYoutubeLabel("en"),
    stat2: "Happy Community",
    stat3Val: "95%",
    stat3: "Success Rate",
    stat4Val: "100%",
    stat4: "Natural & Safe",
    browseTitle: "Browse by Category",
    allRemedies: "All Remedies",
    allCount: "50+",
    skinCare: "Skin Care",
    skinCount: "20+",
    hairCare: "Hair Care",
    hairCount: "15+",
    acnePimples: "Acne & Pimples",
    acneCount: "10+",
    antiAging: "Anti-Aging",
    agingCount: "8+",
    collectionTitle: "Complete DIY Remedy Collection",
    collectionDesc: "Step-by-step guides with exact ingredients, timing and difficulty for every remedy.",
    ingredientsLabel: "Ingredients",
    benefitLabel: "Benefit",
    howToLabel: "How to",
    remediesAvailable: "remedies available",
    diffBeginner: "Beginner",
    diffEasy: "Easy",
    diffMedium: "Medium",
    popularTitle: "Most Popular Remedies",
    popularDesc: "Tried and loved by thousands of community members",
    seasonalTitle: "Seasonal Remedies",
    seasonalDesc: "Special formulations for every Indian season",
    tipsTitle: "Pro Tips & Tricks",
    tipsDesc: "Expert advice to maximize your DIY beauty results",
    ctaTitle: "Ready to Transform Your Beauty Routine?",
    ctaDesc: `Join ${getYoutubeLabel("en")} people who've discovered the power of natural beauty with proven DIY remedies and video tutorials!`,
    btnSubscribeYT: "Subscribe for New Tutorials",
    btnFollowIG: "Follow for Daily Tips",
    newsletterTitle: "Get Weekly DIY Tips & Exclusive Recipes",
    newsletterDesc: "Join our newsletter for the latest natural beauty secrets!",
    newsletterPlaceholder: "Enter your email address",
    btnSubscribe: "Subscribe",
    subscribedMsg: "🎉 You're subscribed! Thank you.",
    emailError: "Please enter a valid email address.",
    testimonialsTitle: "What Our Community Says",
    testimonialsDesc: "Real results from real people across India",
    usedLabel: "Used",
    disclaimerStrong: "⚠️ Important Disclaimer:",
    disclaimerText: "These DIY remedies are based on traditional Ayurvedic knowledge and personal experience. Always",
    patchTest: "perform a patch test",
    disclaimerEnd: "24 hours before full application. Avoid citrus remedies before sun exposure. If you have sensitive skin, allergies, or any skin condition, please consult a certified dermatologist before use.",
    footerTagline: `Natural Beauty • DIY Remedies • ${getYoutubeLabel("en")} Community`,
    footerYT: `YouTube (${getYoutubeLabel("en")})`,
    footerIG: `Instagram (${getInstagramLabel()})`,
    footerHome: "Main Website",
    footerCopy: "Made with 💖 for natural beauty lovers",
    winterSeason: "Winter Special",
    summerSeason: "Summer Cooling",
    monsoonSeason: "Monsoon Care",
    // Video section labels
    videosTitle: "Watch Tutorials",
    videosDesc: "Video guides in your language",
    watchNow: "Watch Now",
    videoViews: "views",
  },

  hi: {
    dir: "ltr",
    font: "'Noto Sans Devanagari', sans-serif",
    headingFont: "'Noto Sans Devanagari', sans-serif",
    siteName: "तान्या फैशन स्किनकेयर",
    siteTagline: "DIY सौंदर्य उपाय",
    navHome: "होम",
    navCategories: "श्रेणियाँ",
    navPopular: "लोकप्रिय",
    navBackHome: "होम पर वापस",
    heroBadge: "50+ सिद्ध प्राकृतिक उपाय",
    heroTitle: "प्राकृतिक सौंदर्य उपाय जो",
    heroHighlight: "वास्तव में काम करते हैं!",
    heroDesc: `सरल रसोई सामग्री से अपनी त्वचा और बालों को बदलें। कोई महंगा उत्पाद नहीं — ${getYoutubeLabel("hi")} समुदाय सदस्यों द्वारा सिद्ध!`,
    tag1: "100% प्राकृतिक",
    tag2: "रसोई सामग्री",
    tag3: "सिद्ध परिणाम",
    tag4: "शून्य दुष्प्रभाव",
    btnYouTube: "YouTube पर ट्यूटोरियल देखें",
    btnAI: "AI फेस विश्लेषण करें",
    stat1Val: "50+",
    stat1: "DIY उपाय",
    stat2Val: getYoutubeLabel("hi"),
    stat2: "खुश समुदाय",
    stat3Val: "95%",
    stat3: "सफलता दर",
    stat4Val: "100%",
    stat4: "प्राकृतिक व सुरक्षित",
    browseTitle: "श्रेणी के अनुसार खोजें",
    allRemedies: "सभी उपाय",
    allCount: "50+",
    skinCare: "त्वचा देखभाल",
    skinCount: "20+",
    hairCare: "बाल देखभाल",
    hairCount: "15+",
    acnePimples: "मुहांसे व पिंपल्स",
    acneCount: "10+",
    antiAging: "एंटी-एजिंग",
    agingCount: "8+",
    collectionTitle: "पूर्ण DIY उपाय संग्रह",
    collectionDesc: "हर उपाय के लिए सटीक सामग्री, समय और कठिनाई के साथ चरण-दर-चरण मार्गदर्शिका।",
    ingredientsLabel: "सामग्री",
    benefitLabel: "लाभ",
    howToLabel: "विधि",
    remediesAvailable: "उपाय उपलब्ध",
    diffBeginner: "शुरुआती",
    diffEasy: "आसान",
    diffMedium: "मध्यम",
    popularTitle: "सबसे लोकप्रिय उपाय",
    popularDesc: "हजारों समुदाय सदस्यों द्वारा आजमाया और पसंद किया गया",
    seasonalTitle: "मौसमी उपाय",
    seasonalDesc: "हर भारतीय मौसम के लिए विशेष फॉर्मूलेशन",
    tipsTitle: "प्रो टिप्स और ट्रिक्स",
    tipsDesc: "DIY सौंदर्य परिणामों को अधिकतम करने के लिए विशेषज्ञ सलाह",
    ctaTitle: "अपनी सौंदर्य दिनचर्या बदलने के लिए तैयार हैं?",
    ctaDesc: `${getYoutubeLabel("hi")} लोगों से जुड़ें जिन्होंने प्राकृतिक सौंदर्य की शक्ति खोजी है!`,
    btnSubscribeYT: "नए ट्यूटोरियल के लिए सब्सक्राइब करें",
    btnFollowIG: "दैनिक टिप्स के लिए फॉलो करें",
    newsletterTitle: "साप्ताहिक DIY टिप्स और एक्सक्लूसिव रेसिपी पाएं",
    newsletterDesc: "नवीनतम प्राकृतिक सौंदर्य रहस्यों के लिए हमारे न्यूज़लेटर से जुड़ें!",
    newsletterPlaceholder: "अपना ईमेल पता दर्ज करें",
    btnSubscribe: "सब्सक्राइब करें",
    subscribedMsg: "🎉 आप सब्सक्राइब हो गए! धन्यवाद।",
    emailError: "कृपया एक मान्य ईमेल पता दर्ज करें।",
    testimonialsTitle: "हमारा समुदाय क्या कहता है",
    testimonialsDesc: "पूरे भारत के वास्तविक लोगों के वास्तविक परिणाम",
    usedLabel: "उपयोग किया",
    disclaimerStrong: "⚠️ महत्वपूर्ण अस्वीकरण:",
    disclaimerText: "ये DIY उपाय पारंपरिक आयुर्वेदिक ज्ञान पर आधारित हैं। हमेशा",
    patchTest: "पैच टेस्ट करें",
    disclaimerEnd: "पूरे आवेदन से 24 घंटे पहले। धूप से पहले खट्टे उपाय न लगाएं। संवेदनशील त्वचा होने पर त्वचा विशेषज्ञ से परामर्श करें।",
    footerTagline: `प्राकृतिक सौंदर्य • DIY उपाय • ${getYoutubeLabel("hi")} समुदाय`,
    footerYT: `YouTube (${getYoutubeLabel("hi")})`,
    footerIG: `Instagram (${getInstagramLabel()})`,
    footerHome: "मुख्य वेबसाइट",
    footerCopy: "प्राकृतिक सौंदर्य प्रेमियों के लिए 💖 के साथ बनाया गया",
    winterSeason: "सर्दियों के लिए",
    summerSeason: "गर्मियों के लिए",
    monsoonSeason: "मानसून देखभाल",
    // Video section labels
    videosTitle: "ट्यूटोरियल देखें",
    videosDesc: "आपकी भाषा में वीडियो गाइड",
    watchNow: "अभी देखें",
    videoViews: "व्यूज़",
  },

  ur: {
    dir: "rtl",
    font: "'Noto Nastaliq Urdu', serif",
    headingFont: "'Noto Nastaliq Urdu', serif",
    siteName: "تانیہ فیشن سکن کیئر",
    siteTagline: "DIY خوبصورتی کے نسخے",
    navHome: "ہوم",
    navCategories: "زمرے",
    navPopular: "مقبول",
    navBackHome: "ہوم پر واپس",
    heroBadge: "50+ آزمودہ قدرتی نسخے",
    heroTitle: "قدرتی خوبصورتی کے نسخے جو",
    heroHighlight: "واقعی کام کرتے ہیں!",
    heroDesc: `سادہ باورچی خانے کی اشیاء سے اپنی جلد اور بالوں کو بدلیں۔ مہنگی مصنوعات کی ضرورت نہیں — ${getYoutubeLabel("ur")} کمیونٹی سے ثابت!`,
    tag1: "100% قدرتی",
    tag2: "باورچی خانے کی اشیاء",
    tag3: "ثابت نتائج",
    tag4: "صفر مضر اثرات",
    btnYouTube: "YouTube پر ٹیوٹوریل دیکھیں",
    btnAI: "AI چہرہ تجزیہ آزمائیں",
    stat1Val: "50+",
    stat1: "DIY نسخے",
    stat2Val: getYoutubeLabel("ur"),
    stat2: "خوش کمیونٹی",
    stat3Val: "95%",
    stat3: "کامیابی کی شرح",
    stat4Val: "100%",
    stat4: "قدرتی و محفوظ",
    browseTitle: "زمرے کے مطابق تلاش کریں",
    allRemedies: "تمام نسخے",
    allCount: "50+",
    skinCare: "جلد کی دیکھ بھال",
    skinCount: "20+",
    hairCare: "بالوں کی دیکھ بھال",
    hairCount: "15+",
    acnePimples: "کیل مہاسے",
    acneCount: "10+",
    antiAging: "اینٹی ایجنگ",
    agingCount: "8+",
    collectionTitle: "مکمل DIY نسخوں کا مجموعہ",
    collectionDesc: "ہر نسخے کے لیے درست اجزاء، وقت اور مشکل کے ساتھ مرحلہ وار رہنمائی۔",
    ingredientsLabel: "اجزاء",
    benefitLabel: "فائدہ",
    howToLabel: "طریقہ",
    remediesAvailable: "نسخے دستیاب",
    diffBeginner: "ابتدائی",
    diffEasy: "آسان",
    diffMedium: "درمیانی",
    popularTitle: "سب سے مقبول نسخے",
    popularDesc: "ہزاروں کمیونٹی اراکین نے آزمایا اور پسند کیا",
    seasonalTitle: "موسمی نسخے",
    seasonalDesc: "ہر ہندوستانی موسم کے لیے خصوصی فارمولیشن",
    tipsTitle: "ماہرانہ ٹپس اور ترکیبیں",
    tipsDesc: "DIY خوبصورتی کے نتائج کو بہتر بنانے کے لیے ماہرانہ مشورہ",
    ctaTitle: "اپنا روزانہ کا خوبصورتی کا معمول بدلنے کے لیے تیار ہیں؟",
    ctaDesc: `${getYoutubeLabel("ur")} لوگوں سے جڑیں جنہوں نے قدرتی خوبصورتی کی طاقت دریافت کی!`,
    btnSubscribeYT: "نئے ٹیوٹوریل کے لیے سبسکرائب کریں",
    btnFollowIG: "روزانہ ٹپس کے لیے فالو کریں",
    newsletterTitle: "ہفتہ وار DIY ٹپس اور خصوصی نسخے پائیں",
    newsletterDesc: "تازہ ترین قدرتی خوبصورتی کے رازوں کے لیے ہمارے نیوز لیٹر سے جڑیں!",
    newsletterPlaceholder: "اپنا ای میل پتہ درج کریں",
    btnSubscribe: "سبسکرائب کریں",
    subscribedMsg: "🎉 آپ سبسکرائب ہو گئے! شکریہ۔",
    emailError: "براہ کرم ایک درست ای میل پتہ درج کریں۔",
    testimonialsTitle: "ہماری کمیونٹی کیا کہتی ہے",
    testimonialsDesc: "پورے بھارت کے حقیقی لوگوں کے حقیقی نتائج",
    usedLabel: "استعمال کیا",
    disclaimerStrong: "⚠️ اہم دستبرداری:",
    disclaimerText: "یہ DIY نسخے روایتی آیورویدک علم پر مبنی ہیں۔ ہمیشہ",
    patchTest: "پیچ ٹیسٹ کریں",
    disclaimerEnd: "مکمل استعمال سے 24 گھنٹے پہلے۔ دھوپ سے پہلے ترش نسخے نہ لگائیں۔ حساس جلد کی صورت میں ماہر امراض جلد سے مشورہ کریں۔",
    footerTagline: `قدرتی خوبصورتی • DIY نسخے • ${getYoutubeLabel("ur")} کمیونٹی`,
    footerYT: `YouTube (${getYoutubeLabel("ur")})`,
    footerIG: `Instagram (${getInstagramLabel()})`,
    footerHome: "مرکزی ویب سائٹ",
    footerCopy: "قدرتی خوبصورتی سے محبت کرنے والوں کے لیے 💖 کے ساتھ بنایا گیا",
    winterSeason: "سردیوں کے لیے",
    summerSeason: "گرمیوں کے لیے",
    monsoonSeason: "مانسون کی دیکھ بھال",
    // Video section labels
    videosTitle: "ٹیوٹوریل دیکھیں",
    videosDesc: "آپ کی زبان میں ویڈیو گائیڈز",
    watchNow: "ابھی دیکھیں",
    videoViews: "ویوز",
  },
};

// ─── Context ──────────────────────────────────────────────────────────────────
const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem("tanya_lang") || "en";
    } catch {
      return "en";
    }
  });

  const t = TRANSLATIONS[lang];

  // Returns only videos matching the currently selected language
  const getVideosForLang = (filterLang = lang) =>
    VIDEOS.filter((v) => v.lang === filterLang);

  const changeLang = (newLang) => {
    setLang(newLang);
    try {
      localStorage.setItem("tanya_lang", newLang);
    } catch {}
    document.documentElement.setAttribute("dir", TRANSLATIONS[newLang].dir);
    document.documentElement.setAttribute("lang", newLang);
  };

  useEffect(() => {
    document.documentElement.setAttribute("dir", t.dir);
    document.documentElement.setAttribute("lang", lang);
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, t, changeLang, getVideosForLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

// ─── Language Switcher ────────────────────────────────────────────────────────
export function LanguageSwitcher() {
  const { lang, changeLang } = useLanguage();

  const langs = [
    { code: "en", label: "EN",  full: "English" },
    { code: "hi", label: "हि",  full: "हिंदी"   },
    { code: "ur", label: "اُر", full: "اردو"    },
  ];

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "2px",
        background: "#f3f4f6",
        borderRadius: "8px",
        padding: "4px",
      }}
    >
      {langs.map(({ code, label, full }) => (
        <button
          key={code}
          onClick={() => changeLang(code)}
          title={full}
          style={{
            padding: "4px 10px",
            borderRadius: "6px",
            border: "none",
            cursor: "pointer",
            fontSize: "13px",
            fontWeight: "600",
            minHeight: "32px",
            minWidth: "36px",
            transition: "all 0.2s",
            background: lang === code ? "white" : "transparent",
            color: lang === code ? "#c2185b" : "#6b7280",
            boxShadow: lang === code ? "0 1px 4px rgba(0,0,0,0.1)" : "none",
            fontFamily:
              code === "hi"
                ? "'Noto Sans Devanagari', sans-serif"
                : code === "ur"
                ? "'Noto Nastaliq Urdu', serif"
                : "'Inter', sans-serif",
          }}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export const useLanguage = () => useContext(LanguageContext);